import React from "react";
import { Route } from "react-router-dom";
import { IonReactRouter } from "@ionic/react-router";
import {
  IonTabs,
  IonRouterOutlet,
  IonTabBar,
  IonSplitPane,
  IonMenu,
  IonPage,
  IonTabButton,
  IonIcon,
  IonLabel,
} from "@ionic/react";
import SideMenu from "components/sideMenu";
import { authRoute, tabMenu } from "helpers/staticData";
import { Synchronize } from "pages";
import MainRoute from "./mainRoute";
import AppUrlListener from "pages/appUrlListener";

function Index() {
  return (
    <IonReactRouter>
      <IonRouterOutlet>
        {/* Auth Router */}
        {authRoute.map((item, index) => (
          <Route key={index} exact={item.exact} path={item.url}>
            {item.component}
          </Route>
        ))}
        <IonTabs>
          <IonRouterOutlet>
            <IonSplitPane when="lg" contentId="main-content">
              <IonMenu contentId="main-content" swipeGesture={false}>
                {/* Side Menu */}
                <SideMenu />
              </IonMenu>
              <IonPage id="main-content">
                <AppUrlListener />
                {/* Main Router */}
                <MainRoute />

                <Route exact path="/">
                  <Synchronize />
                </Route>
              </IonPage>
            </IonSplitPane>
          </IonRouterOutlet>
          <IonTabBar slot="bottom" mode="md">
            {/* Tab Menu */}
            {tabMenu.map((item, index) => (
              <IonTabButton
                key={index}
                tab={item.title}
                href={item.url}
                className={`tabbutton-${item?.id} reset`}
              >
                <IonIcon icon={item.icon} />
                <IonLabel className="tabLabel">{item.title}</IonLabel>
              </IonTabButton>
            ))}
          </IonTabBar>
        </IonTabs>
      </IonRouterOutlet>
    </IonReactRouter>
  );
}

export default Index;
